import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { BusinessService } from '../business.service';

@Component({
  selector: 'app-business-detail',
  templateUrl: './business-detail.component.html',
  styleUrls: ['./business-detail.component.scss']
})
export class BusinessDetailComponent implements OnInit {

  @ViewChild("view") public view: ViewComponent;
  public business: any = {};
  constructor(
    private businessService: BusinessService,

    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private coreDialogService: CoreDialogService,
  ) { }

  ngOnInit(): void {
    this.loadBusiness(this.config.data.id);
  }

  loadBusiness(id) {
    if (id) {
      this.businessService.get(id).subscribe(
        data => {
          this.business = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  save(event: any) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (typeof this.business.id === "undefined") {
      this.businessService.add(this.business).subscribe(
        data => {
          this.dynamicDialogRef.close();
          this.messageService.add({ closable: false, severity: 'success', summary: "Empresa añadida correctamente." });
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.businessService.save(this.business.id, this.business).subscribe(
        data => {
          this.businessService.add({ closable: false, severity: "success", detail: "Empresa guardada correctamente" });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la empresa " + this.business.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.businessService.delete(this.business.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrada correctamente" });
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }

  isDuplied(business, event) {
    if (business.name == null || business.name == ""){
      this.messageService.add({ closable: false, severity: "error", detail: "El nombre no puede estar vacío." });
      return;
    }
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    this.businessService.isDuplied(business).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe una empresa con estos datos proporcionados.",
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save(event);
        }
      }
    );
  }

  onEvent(event) {
    if (event.component == "business.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(this.business, event);
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      this.config.header = typeof (this.business.id) !== "undefined" ? "Detalles de la " + this.view.getEntityBaseName() : "Nueva " + this.view.getEntityBaseName();
    }
  }
}
